import { render } from "./richTextEditDia.vue?vue&type=template&id=2af68ca4"
import script from "./richTextEditDia.vue?vue&type=script&lang=js"
export * from "./richTextEditDia.vue?vue&type=script&lang=js"

import "./richTextEditDia.vue?vue&type=style&index=0&id=2af68ca4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__